export const PREFS_OPTED_OUT_COOKIE = "discover_prefs_opted_out";

export const PREFS_OPTED_OUT_VALUE = "1";
